const TenAcTitle = '“十年如一，始终前行”'
const IMAGE_MAP = {
    audio: 'https://p.gsxcdn.com/2412707593_jbarnbxa.png',
    loading: 'https://p.gsxcdn.com/2392080918_zottqg2s.png',
    arrow: 'https://p.gsxcdn.com/2423118028_ht8w87hh.png',
    cover: 'https://p.gsxcdn.com/2402531921_w46k5nm4.png',
    cover_bg: 'https://p.gsxcdn.com/2411723284_ia9oxjis.png',
    cover_back: 'https://p.gsxcdn.com/2412856329_su4xwooh.png',
    book_line: 'https://p.gsxcdn.com/2394690494_c6dbuaxj.png',
    page_line: 'https://p.gsxcdn.com/2412855668_q9jj75e9.png',
    gao_tu: 'https://p.gsxcdn.com/2403026068_r2tlrodg.png',
    one_title: 'https://i.gsxcdn.com/2473507617_om71grea.png',
    one_top: 'https://p.gsxcdn.com/2472681442_hppfv9w6.png',
    two_star: 'https://p.gsxcdn.com/2404130372_8jm6uo3m.svg',
    two_title: 'https://i.gsxcdn.com/2473513236_9bthdf45.png',
    two_top: 'https://p.gsxcdn.com/2431284230_ojl2g7t2.png',
    two_rocket: 'https://i.gsxcdn.com/2456536107_bvta75lq.png',
    two_computer: 'https://p.gsxcdn.com/2412726737_q2imlcwr.png',
    two_desk: 'https://p.gsxcdn.com/2411709928_vsgit6hb.png',
    two_jj: 'https://p.gsxcdn.com/2423157161_b01puimc.png',
    two_block: 'https://p.gsxcdn.com/2423155939_81gr241h.png',
    three_title: 'https://i.gsxcdn.com/2473515283_e6dm4qzg.png',
    three_top: 'https://p.gsxcdn.com/2420721031_ig6rlsoc.png',
    three_cloud: 'https://p.gsxcdn.com/2455979138_zr7g5wbj.png',
    four_teacher: 'https://p.gsxcdn.com/2404454219_ad2snc6q.png',
    four_teacher_small: 'https://i.gsxcdn.com/2460247276_kfo5elsa.png',
    four_title: 'https://i.gsxcdn.com/2473519462_3qcdtx3j.png',
    four_top: 'https://i.gsxcdn.com/2457870430_94ozbw5l.png',
    four_line: 'https://p.gsxcdn.com/2405616809_q6at8lfg.png',
    five_title: 'https://i.gsxcdn.com/2473524382_f9t6i1wm.png',
    five_top: 'https://i.gsxcdn.com/2460282768_pf74w4z7.png',
    five_light: 'https://p.gsxcdn.com/2406189474_edmkonyj.png',
    five_breath: 'https://p.gsxcdn.com/2405678392_tz2gr531.png',
    six_title: 'https://i.gsxcdn.com/2473527020_joecr65p.png',
    six_bg: 'https://p.gsxcdn.com/2411844933_gl9ordxp.png',
    six_bg_next: 'https://p.gsxcdn.com/2411851742_7e9hh89p.png',
    six_nsdk: 'https://i.gsxcdn.com/2457874483_6dlc37ou.png',
    six_yq: 'https://p.gsxcdn.com/2454597183_vsi4llse.png',
    seven_envelope: 'https://p.gsxcdn.com/2406158319_pntmtnuv.png',
    seven_enbg: 'https://p.gsxcdn.com/2406178653_vx796y1z.png',
    seven_top: 'https://i.gsxcdn.com/2460282767_tpm53s6q.png',
    seven_title: 'https://i.gsxcdn.com/2473530547_m9pcnz7l.png',
    seven_avator: 'https://p.gsxcdn.com/2406192727_opfeegrh.png',
    eight_title: 'https://i.gsxcdn.com/2473532698_jq7bbfgr.png',
    eight_top: 'https://p.gsxcdn.com/2424974190_8te5sf4f.png',
    nine_title: 'https://i.gsxcdn.com/2473534861_dbyd734t.png',
    nine_top: 'https://i.gsxcdn.com/2473538015_ikkkg2u9.png',
    nine_msg: 'https://p.gsxcdn.com/2433927773_xh4zsn9j.png',
    nine_img: 'https://i.gsxcdn.com/2456543583_0h9hfq4n.png',
    nine_yuan: 'https://p.gsxcdn.com/2424423356_evhfvzwy.png',
    ten_top1: 'https://p.gsxcdn.com/2410444158_43ho7rue.png',
    ten_union: 'https://p.gsxcdn.com/2410883138_8m8m6qua.png',
    ten_bg1: 'https://p.gsxcdn.com/2410680696_6dn0yyp1.png',
    ten_bg2: 'https://p.gsxcdn.com/2410682889_tfd83ytr.png',
    ten_poster_bg1: 'https://i.gsxcdn.com/2483958037_ytaslpz6.png',
    ten_poster_bg2: 'https://i.gsxcdn.com/2483958042_pn5t69mj.png',
    ten_poster_default1: 'https://i.gsxcdn.com/2483958038_k3to15wg.png',
    ten_poster_default2: 'https://i.gsxcdn.com/2483958039_p9w85i9r.png',
    ten_poster_box: 'https://p.gsxcdn.com/2410703167_c0m96q0l.png',
    ten_poster_human: 'https://p.gsxcdn.com/2410703167_c0m96q0l.png',
    ten_poster_svg: 'https://p.gsxcdn.com/2410805873_7u3sou7p.svg',
    ten_poster_title: 'https://i.gsxcdn.com/2483951273_24gtp7j2.png',
    ten_poster_gotu: 'https://p.gsxcdn.com/2410890145_a2mmdruo.png',
    ten_poster_qr: 'https://p.gsxcdn.com/2422233058_uopcf6j4.png',
    share_comunity: 'https://p.gsxcdn.com/2421856235_r8oicxh1.png',
    share_wx_comment: 'https://p.gsxcdn.com/2421009435_sc7c119k.png',
    share_wx: 'https://p.gsxcdn.com/2421009657_3ztzdcas.png',
    share_copy: 'https://p.gsxcdn.com/2421010186_iutlcdqh.png',
    share_load: 'https://p.gsxcdn.com/2421010995_xe350602.png',
    share_wx_icon: 'https://p.gsxcdn.com/2422243403_o4hhnop3.png',
}

const CityImgList = [
    [
        'https://p.gsxcdn.com/2407295885_bnhklsvt.png',
        'https://p.gsxcdn.com/2407295874_b0jlrmgd.png',
        'https://p.gsxcdn.com/2407295887_d5vnevkd.png',
        'https://p.gsxcdn.com/2407295875_idwkejc2.png',
    ],
    [
        'https://p.gsxcdn.com/2407295879_078t7ibz.png',
        'https://p.gsxcdn.com/2407295878_5caeot6c.png',
        'https://p.gsxcdn.com/2407295877_mwppa8ml.png',
        'https://p.gsxcdn.com/2407295876_ky5duksz.png',
    ],
    [
        'https://p.gsxcdn.com/2407295880_u2n8va2y.png',
        'https://p.gsxcdn.com/2407295884_j9sxlty3.png',
        'https://p.gsxcdn.com/2407295882_nrmuqafl.png',
    ],
]

const Lottie_Map = {
    hand: 'https://p.gsxcdn.com/2405611259_wu0r2e5e.json',
    rocket: 'https://p.gsxcdn.com/2404355566_96ia1mbp.json',
    knock: 'https://p.gsxcdn.com/2420739377_gl5wf6md.json',
    food: 'https://p.gsxcdn.com/2406337650_cnfw29je.json',
    loading: 'https://p.gsxcdn.com/2411572467_kns3mgbt.json',
    audio: 'https://p.gsxcdn.com/2413066064_5ylsu3x4.json',
    flower: 'https://p.gsxcdn.com/2424790170_boym1i05.json',
    cake: 'https://p.gsxcdn.com/2428349100_twhdo0rr.json',
    load: 'https://p.gsxcdn.com/2431599146_ij7rpdld.json',
    video: 'https://p.gsxcdn.com/2469918605_2z4q6574.json',
    popup: 'https://p.gsxcdn.com/2459612895_wl0ufps6.json',
    star: 'https://p.gsxcdn.com/2455338512_8b8xpxva.json',
    gudie: 'https://p.gsxcdn.com/2443917313_x3yqiag4.json',
    shake_hand: 'https://p.gsxcdn.com/2456399493_2rbvamlk.json',
}
const Audio_Map = {
    bg: 'https://p.gsxcdn.com/2412711966_8bq5eqj6.mp3',
    video: 'https://p.gsxcdn.com/2412711968_qf8rlvbf.MP3',
    rocket: 'https://p.gsxcdn.com/2456557332_ix73lf1t.MP3',
    open: 'https://p.gsxcdn.com/2456557333_lwwgbrne.MP3',
    land: 'https://p.gsxcdn.com/2456557337_im954wkp.MP3',
    class: 'https://p.gsxcdn.com/2456557334_4szqqm3g.MP3',
    send: 'https://p.gsxcdn.com/2412891581_4vcmgryf.MP3',
    paper: 'https://p.gsxcdn.com/2412891946_ri73borl.MP3',
    knock: 'https://p.gsxcdn.com/2456557339_5xkl2w66.MP3',
    hand: 'https://p.gsxcdn.com/2412891242_m59kfhov.MP3',
    tv: 'https://p.gsxcdn.com/2456119756_kza9c079.MP3',
    lingsheng: 'https://p.gsxcdn.com/2456557334_4szqqm3g.MP3',
    book: 'https://p.gsxcdn.com/2456557331_0ov3clsx.MP3',
}

const CombineImage_Map = {
    cake_1: 'https://p.gsxcdn.com/2427853929_srfcgiw2.png',
    cake_2: 'https://p.gsxcdn.com/2427853938_aq05z65s.png',
    cake_3: 'https://p.gsxcdn.com/2427853936_xi9p10et.png',
    cake_4: 'https://p.gsxcdn.com/2431148269_1papoxc3.png',
    cake_5: 'https://p.gsxcdn.com/2427853931_lar8j926.png',
    cake_6: 'https://p.gsxcdn.com/2427853930_hlcf1i4m.png',
    child_title: 'https://p.gsxcdn.com/2443524597_23icr1ku.png',
    main_title: 'https://p.gsxcdn.com/2425365295_y3jejye8.png',
    sign_icon: 'https://p.gsxcdn.com/2454696383_l7sn8fo4.png',
    sub_cake: 'https://i.gsxcdn.com/2456348883_2frxt71b.png',
    sub_cake_gray: 'https://i.gsxcdn.com/2456350576_3pqmg5mg.png',
    combine_title: 'https://i.gsxcdn.com/2465137992_npvchj9x.png',
    popup_title: 'https://i.gsxcdn.com/2460273803_w6pqexkx.png',
    popup_bg: 'https://p.gsxcdn.com/2431150256_glq61yig.png',
    new_icon: 'https://p.gsxcdn.com/2426653166_d666vyit.png',
    btn_hand: 'https://p.gsxcdn.com/2427866381_q12r1f06.png',
    left_hand: 'https://p.gsxcdn.com/2443850837_w8id8nt4.png',
    right_hand: 'https://p.gsxcdn.com/2429315512_7s5xz0a0.png',
    gift_car: 'https://p.gsxcdn.com/2431192751_wgvb5b3s.png',
    gift_gold: 'https://p.gsxcdn.com/2431192752_5662xuop.png',
    gift_pad: 'https://p.gsxcdn.com/2431192754_98wjvcq8.png',
    gift_camera: 'https://p.gsxcdn.com/2432272257_ds6bip5z.png',
    gift_card: 'https://p.gsxcdn.com/2444011361_igzn7lzy.png',
    child_lock: 'https://p.gsxcdn.com/2433875646_chfl1p8w.png',
    share_wx_icon: 'https://p.gsxcdn.com/2445167000_ia6l6lx0.png',
    share_wx_icon_good: 'https://p.gsxcdn.com/2445168358_v22xueil.png',
}
const ActivityId = '2024anniversary'
export {
    IMAGE_MAP,
    TenAcTitle,
    Lottie_Map,
    CityImgList,
    Audio_Map,
    CombineImage_Map,
    ActivityId,
}
